var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCrossOriginWorkerURL } from "@auvious/utils";
var MessageType;
(function (MessageType) {
    MessageType[MessageType["CREATE"] = 0] = "CREATE";
    MessageType[MessageType["GETTER"] = 1] = "GETTER";
    MessageType[MessageType["SETTER"] = 2] = "SETTER";
    MessageType[MessageType["APPLY"] = 3] = "APPLY";
    MessageType[MessageType["CLOSE"] = 4] = "CLOSE";
})(MessageType || (MessageType = {}));
class Channel {
    constructor(url, options, assetsLocation) {
        this.url = url;
        this.options = options;
        this.assetsLocation = assetsLocation;
        this.reqs = new Map();
        this.id = 0;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const workerUrl = yield getCrossOriginWorkerURL(`${this.assetsLocation}/mqtt.worker.js`);
            this.worker = new Worker(workerUrl);
            // if (workerUrl.startsWith("blob:")) {
            //   URL.revokeObjectURL(workerUrl);
            // }
            this.worker.postMessage({
                type: MessageType.CREATE,
                id: this.id++,
                url: this.url,
                options: this.options,
            });
            this.worker.onerror = (e) => {
                // let sentry catch it
                throw e;
            };
            this.worker.onmessage = ({ data, }) => {
                const req = this.reqs.get(data.id);
                if (data.isCallback) {
                    req.resolve(...data.values);
                }
                else {
                    data.throws ? req.reject(...data.values) : req.resolve(...data.values);
                    this.reqs.delete(data.id);
                }
            };
        });
    }
    getter(...path) {
        return new Promise((resolve, reject) => {
            const id = this.id++;
            this.reqs.set(id, { resolve, reject });
            this.worker.postMessage({
                type: MessageType.GETTER,
                id,
                path,
            });
        });
    }
    setter(value, ...path) {
        this.worker.postMessage({
            type: MessageType.SETTER,
            path,
            value,
        });
    }
    applier(method, ...args) {
        return new Promise((resolve, reject) => {
            const id = this.id++;
            this.reqs.set(id, { resolve, reject });
            let callback = -1;
            const hasCallback = args[args.length - 1] instanceof Function;
            if (hasCallback) {
                this.reqs.set((callback = this.id++), { resolve: args.pop() });
            }
            this.worker.postMessage({
                type: MessageType.APPLY,
                id,
                callback,
                method,
                args,
            });
        });
    }
    end() {
        this.worker.postMessage({ type: MessageType.CLOSE });
        this.reqs.clear();
    }
}
export function connect(url, options, assetsLocation) {
    return __awaiter(this, void 0, void 0, function* () {
        const channel = new Channel(url, options, assetsLocation);
        yield channel.init();
        const client = {
            getConnected() {
                return channel.getter("connected");
            },
            setConnected(arg) {
                channel.setter(arg, "connected");
            },
            addListener(...args) {
                return channel.applier("addListener", ...args);
            },
            subscribe(topic, opts, callback) {
                return channel.applier("subscribe", topic, opts, callback);
            },
            unsubscribe(...args) {
                return channel.applier("unsubscribe", ...args);
            },
            end(force, callback) {
                channel.applier("end", force, () => {
                    callback();
                    channel.end();
                });
            },
            options: {
                getUsername() {
                    return channel.getter("options", "username");
                },
                setUsername(arg) {
                    channel.setter(arg, "options", "username");
                },
                getPassword() {
                    return channel.getter("options", "password");
                },
                setPassword(arg) {
                    channel.setter(arg, "options", "password");
                },
            },
        };
        return client;
    });
}
// class A {
//   public a;
//   constructor(b) {
//     this.a = { b };
//   }
//   public foo(f) {
//     window.setTimeout(f, 1000, 42);
//   }
// }
// const ctr = {};
// Object.setPrototypeOf(
//   A.prototype,
//   new Proxy(ctr, {
//     set(t, k, v, r) {
//       console.log("icu set", t, k, v, r);
//       Reflect.set(ctr, k, v);
//       return true;
//     },
//   })
// );
// const a = new A(3);
//# sourceMappingURL=Mqtt.js.map